/** Approved city-specific snippets; no route amounts belong in metadata. */
export const ROTTERDAM_META = {
  nl: {
    title: "Taxi Rotterdam | Vaste Prijs Tot 50% Goedkoper | Taxiritje.nl",
    description: "Taxi Rotterdam met vaste prijs vooraf, tot 50% goedkoper dan de taximeter. Auto of taxibus voor 5–8 personen naar stad of luchthaven. Bereken en boek online.",
  },
  en: {
    title: "Taxi Rotterdam | Fixed Price, Save Up to 50% | Taxiritje.nl",
    description: "Taxi Rotterdam at a fixed price, up to 50% less than the meter. Car or minibus for 5–8 passengers to the city or airport. Calculate and book online.",
  },
} as const;

export const ROTTERDAM_NEIGHBOURS = new Set([
  "schiedam", "barendrecht", "vlaardingen", "capelle-aan-den-ijssel", "ridderkerk",
]);